package br.com.vvrefeicoes.portal.data.remote

import br.com.vvrefeicoes.portal.domain.model.PermissionAction
import kotlinx.serialization.Serializable

/** Corpo de `POST /auth/login`. */
@Serializable
data class LoginRequestDto(
    val email: String,
    val password: String,
)

/** Corpo de `POST /auth/refresh`. */
@Serializable
data class RefreshRequestDto(
    val refreshToken: String,
)

/** Corpo de `POST /auth/password/forgot`. */
@Serializable
data class ForgotPasswordRequestDto(
    val email: String,
)

/** Corpo de `POST /auth/password/verify`. */
@Serializable
data class VerifyResetCodeRequestDto(
    val email: String,
    val code: String,
)

/** Resposta de `POST /auth/password/verify`. */
@Serializable
data class VerifyResetCodeResponseDto(
    val resetToken: String,
)

/** Corpo de `POST /auth/password/reset`. */
@Serializable
data class ResetPasswordRequestDto(
    val resetToken: String,
    val newPassword: String,
    val confirmPassword: String,
)

/** Resposta de `POST /auth/login` e `POST /auth/refresh`. */
@Serializable
data class LoginResponseDto(
    val token: String,
    val refreshToken: String,
    val user: AuthenticatedUserDto,
    val permissions: Map<String, Set<PermissionAction>> = emptyMap(),
)

@Serializable
data class AuthenticatedUserDto(
    val id: String,
    val nome: String,
    val email: String = "",
    val perfilAcesso: String? = null,
    val permissions: Map<String, List<String>> = emptyMap(),
    val companies: List<LoginCompanyDto> = emptyList(),
)

@Serializable
data class LoginCompanyDto(
    val id: String,
    val name: String,
)
